// extracted by mini-css-extract-plugin
export default {"root":"root--wi2q9","draggableHeader":"draggableHeader--OX0EH"};